import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=f8f9165e&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"
import style0 from "./downLoad.vue?vue&type=style&index=0&id=f8f9165e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f9165e",
  null
  
)

export default component.exports